import React, { useState, useEffect, useMemo ,useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import ResultPage from '../ResultPage/ResultPage'
import ResultTwo from '../ResultTwo/ResultTwo'
import Dashboard from '../Dashboard/Dashboard'
import "./ResultAll.css";
import lockIcon from "../../images/lock1.svg";
import girl from "../../images/girl.png";
import star from "../../images/star.png";
import redb from "../../images/red-badge.svg";
import Subscriptions from '../Subscriptions/Subscriptions'; 
import Strength from '../Strength/Strength';
import ResultChart from '../ResultChart/ResultChart';
import DarkResult from '../DarkResult/DarkResult';
import ResultSlider from '../ResultSlider/ResultSlider';
import { useParams } from "react-router-dom";
import { END_URL, IMG_URL } from "../../config";
import axios from 'axios';
import lock from "../../images/lock1.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import loadimg from "../../images/loader_wish.gif";


const Loader = () => (
    <div className="loader-overlay">
        <div className="loader-spinner"></div>
        <p>Loading results...</p>
    </div>
);

function AdminResult() {


    const contentRefs = useRef([]);

    const { result } = useParams();


    const [testData, settestData] = useState([]);

    const [Demension, setDemension] = useState([]);

    const [Cluster, setCluster] = useState([]);


    const [getBladge, setgetBladge] = useState([]);


    const [LocalTest, setSubcription] = useState([]);


    const [hasplan, setHasPlan] = useState({});

    const [HavePastTest, setHavePastTest] = useState(false);

    const [hasSubscription, setHasSubscription] = useState(false);
      
    
    const [Opacity, setOpacity] = useState(true);

    const [SubPlan, setSubPlan] = useState({});


    const [isLoading, setIsLoading] = useState(true);

    const [ResultLast, setResultLast] = useState(true);

    const [resultReady, setResultReady] = useState(false);

    const [result_letter, setresult_letter] = useState([]);

    const [FilterSideMenu, setFilterSideMenu] = useState([]);

    const onLoginChange = () => {
   
    console.log("Login state changed!");
    };
    
   const token = "";

    useEffect(() => {

            setIsLoading(true);

            FetchResultData();
        

    }, []);


    useEffect(() => {
        console.log("Demension updated:", Demension);
        if (Demension && typeof Demension === 'object' && Object.keys(Demension).length > 0) {
            setResultReady(true);
        }
    }, [Demension]);

    const FetchResultData = async () => {

        try {

            const response = await fetch(`${END_URL}/admin-result/${result}`, {

                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },

            });

            const data = await response.json();

            setDemension(data.dimensions);

            setCluster(data.cluster);

            setgetBladge(data.bladge);

            setHavePastTest(data.have_past_test);

            setresult_letter(data.result_letter.split(""));

            if (data.dimensions?.dimension_content?.length > 0) {

                const headingItems = data.dimensions.dimension_content.filter(item => item.type === 'heading');

                const formattedFilterMenu = [
                    { id: "result", title: data.dimensions?.name || "Result Overview" }
                ];

                if(token)
                {
                    formattedFilterMenu.push({ id: "badge", title: "Badges Earned" });
                }

                formattedFilterMenu.push({ id: "test", title: (data?.test?.name || '') + '-' + (data.dimensions?.name || '') });

                headingItems.forEach(item => {
                    if (item.id && item.value) {

                        const headingslug = item.value.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '');

                        formattedFilterMenu.push({ id: headingslug, title: item.value });
                    }
                });

                setFilterSideMenu(formattedFilterMenu);
            }

            setHasPlan(data.hasplan);

            if (data.data && data.data.length > 0)
            {
                settestData({
                    test: data.test,
                    data: data.data
                });
            }
            else
            {
                settestData(LocalTest);
            }

        } catch (error) {

            console.error("Error sending result:", error);
        }
        finally {

            setIsLoading(false);
        }
    };

    const handleSliderImageLoaded = () => {
        setResultReady(true);  
    };



    const subplan = "";

    return (
        <div>

            {isLoading || !resultReady ? (
                
                <div className="loader-container">

                    <img src={loadimg} alt="Loading..." className="loader-gif" />

                </div>

            ) : (
                <div className='result-cont'>

                    {Demension && 

                        <ResultSlider dimension={Demension} onImageLoadComplete={handleSliderImageLoaded} />
                    }
 
                    <div className="container-fluid for-sidebar">

                        <div className="row result-cont-row">
                
                            <div className={`col-12 col-sm-12 col-md-9 col-lg-9 full-width`}>

                          
                                    <>
                                        <ResultPage  subs = {hasSubscription} Has={hasplan} plan={SubPlan} onLoginChange={onLoginChange} subplan={subplan} token={token} testdata={testData} subcribed={Opacity} result={result_letter} demension={Demension} badge={getBladge} />

                           
                                    
                                        <Strength type="free_result" resultRef={contentRefs} onLoginChange={onLoginChange} subs = {hasSubscription} Has={hasplan} plan={SubPlan} ResultLast={ResultLast}  subplan={subplan} token={token} testdata={testData} subcribed={hasSubscription} result={FilterSideMenu.filter(item => typeof item.id === 'number')} badge={'admin'} demension={Demension} />
                                       

                                    </>
                                
                            </div>


                        </div>
                    </div>

                </div>


            )}
        </div>
    );


}

export default AdminResult